import type { ScreenModule } from "../../../app/screen-module";
import { LoginPage } from "../auth-pages";

export default {
	id: "public.login",
	path: "/login",
	area: "public",
	label: "ログイン",
	roles: [],
	backing: "ZEROVIA",
	enabled: true,
	component: LoginPage,
} satisfies ScreenModule;
